'use client';

import * as React from 'react';
import Link from 'next/link';
import { BarChart3 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * The per-row "View analytics" action for the Recent Meetings list. A round
 * icon control that matches the existing `CopyLinkIconButton` pattern exactly
 * (same size, border and hover), so the row's action cluster stays consistent.
 * `stopPropagation` keeps a tap from also triggering the row's open action.
 */
export function AnalyticsLinkButton({
  meetingId,
  leadName,
  href,
  className,
}: {
  meetingId: string;
  leadName: string;
  /** Meeting/Room unification — override for a Room-Provider row
   *  (`/r/{roomId}/analytics`); defaults to the Meeting-model path. */
  href?: string;
  className?: string;
}) {
  return (
    <Link
      href={href ?? `/m/${meetingId}/analytics`}
      onClick={(e) => e.stopPropagation()}
      aria-label={`View analytics for ${leadName}`}
      title="View analytics"
      className={cn(
        'grid h-9 w-9 shrink-0 place-items-center rounded-full border transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--focus-ring)]',
        'border-[var(--border)] bg-[var(--surface)] text-[var(--text-secondary)] hover:border-[color-mix(in_srgb,var(--primary)_35%,transparent)] hover:text-[var(--primary)]',
        className,
      )}
    >
      <BarChart3 className="h-4 w-4" aria-hidden="true" />
    </Link>
  );
}
